export default __webpack_public_path__ + "images/first-column-badge-blocked.svg";